import React from 'react';
import { Chip, LinearProgress, Stack, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { BieMoney } from '../bie/BieValue';

export const ForecastMoneyCell = (p: GridRenderCellParams) => (
  <Typography variant="body2" sx={{ width:'100%', textAlign:'right', fontWeight:700, color:Number(p.value||0)<0?'error.main':'text.primary' }}>
    <BieMoney value={p.value} />
  </Typography>
);

export const ForecastVarianceCell = (p: GridRenderCellParams) => {
  const v = Number(p.value || 0);
  return <Typography variant="body2" sx={{ width:'100%', textAlign:'right', fontWeight:800, color:v<0?'error.main':v>0?'success.main':'text.secondary' }}><BieMoney value={v} /></Typography>;
};

export const ForecastPercentCell = (p: GridRenderCellParams) => {
  const v = Number(p.value || 0);
  return <Typography variant="body2" sx={{ width:'100%', textAlign:'right', fontWeight:700, color:v<0?'error.main':v>0?'success.main':'text.secondary' }}>{v.toLocaleString('fr-FR',{maximumFractionDigits:2})}%</Typography>;
};

export const ForecastStatusChip = (p: GridRenderCellParams) => {
  const v = String(p.value || p.row.status || p.row.sts || '').toUpperCase();
  let color:any = 'default';
  if (['COMMITTED','APPROVED','RECONCILED','VALIDATED','SUCCESS'].includes(v)) color = 'success';
  if (['DRAFT','PENDING','RUNNING','OPEN'].includes(v)) color = 'warning';
  if (['FAILED','ERROR','REJECTED'].includes(v)) color = 'error';
  if (['MODEL_OUTPUT','FORECAST','GENERATED'].includes(v)) color = 'info';
  return <Chip size="small" label={v || '-'} color={color} />;
};

export const ForecastConfidenceCell = (p: GridRenderCellParams) => {
  const raw = Number(p.value || 0);
  const pct = raw <= 1 ? raw * 100 : raw;
  return <Stack spacing={0.5} sx={{width:'100%',pt:0.5}}><Typography variant="caption" sx={{fontWeight:700}}>{pct.toLocaleString('fr-FR',{maximumFractionDigits:1})}%</Typography><LinearProgress variant="determinate" value={Math.max(0,Math.min(100,pct))} sx={{height:7,borderRadius:5}} /></Stack>;
};

export const ForecastDeltaClass = (p:any) => Number(p.value||0)<0 ? 'forecast-negative' : Number(p.value||0)>0 ? 'forecast-positive' : '';
export const ForecastGridSx = {
  '& .forecast-positive': { color:'success.main', fontWeight:800 },
  '& .forecast-negative': { color:'error.main', fontWeight:800 },
  '& .forecast-warning-row': { bgcolor:'#fff8e1' },
  '& .forecast-error-row': { bgcolor:'#ffebee' },
  '& .forecast-success-row': { bgcolor:'#e8f5e9' },
};
